var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"flex items-center w-full h-16 shadow-lg shadow-b"},[_vm._t("tabs")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }